/* eslint no-useless-escape:0, jsx-a11y/anchor-is-valid: 0 */
// import _ from 'lodash'
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import { getTranslate } from 'react-localize-redux';
import { isEqual } from 'lodash';

import { lockScroll, showAuthenticationPopup } from '../../actions/common/index';
import { removeFromCart, deleteFromCart, getCart, processCart, updateCart } from '../../actions/shopping-cart/index';
import { moneyFormat } from '../../assets/util';
// import img150 from '../../img/150x150/img1.jpg';

// import $$ from 'jquery';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import IconCart from '../../assets/icon/IconCart';
import { isServer } from '../../store'
import { faShoppingCart, faTimes } from '@fortawesome/pro-light-svg-icons';
class HeaderCart extends Component {

    constructor(props) {
        super(props);

        this.state = {
            cartVisible: false,
            forceCloseCart: false,
            vh: isServer ? 0 : window.innerHeight,
        }
        this.renderItem = this.renderItem.bind(this);
        this.cartHandleClick = this.cartHandleClick.bind(this);
        this.cartHandleOutsideClick = this.cartHandleOutsideClick.bind(this);
    }

    componentDidMount() {
        if (this.props.authenticated) {
            this.props.getCart();
        }

        this.updateDimensions()

        window.addEventListener("resize", this.updateDimensions.bind(this));
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.updateDimensions.bind(this));
    }

    componentWillReceiveProps(nextProps) {
        if (!isEqual(this.props.items, nextProps.items)) {
            if (nextProps.authenticated) {
                this.props.getCart();
            } else {
                this.props.processCart(nextProps.items);
            }
        }

        // if (this.props.authenticated !== nextProps.authenticated && nextProps.authenticated === false) {
        //     nextProps.updateCart([]);
        // } else if (this.props.authenticated === false && nextProps.authenticated === true) {
        //     // console.log ("getCart !auth to auth")
        //     nextProps.getCart(true);
        // }
    }

    componentDidUpdate(prevProps, prevState) {
        // Object.entries(this.props).forEach(([key, val]) =>
        //     !_.isEqual(prevProps[key], val) && console.log(`Prop '${key}' changed`, prevProps[key], val)
        // );
        // if (this.state) {
        //     Object.entries(this.state).forEach(([key, val]) =>
        //     !_.isEqual(prevState[key], val) && console.log(`State '${key}' changed`, prevState[key], val)
        //     );
        // }
        if (this.state.cartVisible && !prevState.cartVisible && this.props.willLock) {
            this.props.lockScroll(true)
        } else if (!this.state.cartVisible && prevState.cartVisible) {
            this.props.lockScroll(false)
        }

        if (this.props.authenticated !== prevProps.authenticated && this.props.authenticated === false) {
            this.props.updateCart([]);
        } else if (this.props.authenticated === true && prevProps.authenticated === false) {
            this.props.getCart(true);
        }

        if (this.props.location.pathname !== prevProps.location.pathname) {
            this.setState({ forceCloseCart: true });
        }

        if (this.props.updateHeight !== prevProps.updateHeight) {
            setTimeout(() => this.updateDimensions(), 400);
        }
    }

    updateDimensions() {
        if (!this.cartWindow) return null;
        const top = this.cartWindow.getBoundingClientRect().top;
        const h = window.innerHeight - top
        let vh = window.innerWidth < 1200 ? window.innerHeight * 0.01 * 100 : h;
        this.setState({ vh });
    }

    cartHandleClick() {
        if (!this.state.cartVisible) {
            document.addEventListener('click', this.cartHandleOutsideClick, false);
            this.updateDimensions();
        } else {
            document.removeEventListener('click', this.cartHandleOutsideClick, false);
        }

        this.setState(prevState => ({
            cartVisible: !prevState.cartVisible
        }))
    }

    cartHandleOutsideClick(e) {
        if (this.cartBox.contains(e.target)) {
            return;
        }
        this.cartHandleClick();
    }

    renderItem(item, index) {
        const info = item.info
        if (!info) return null;
        return (
            <div key={index} className="item-row">
                <img src={info.image_cart} alt={info.mat_name} />
                <div className="item-detail">
                    <div className="title"><div className="brand">{info.brand_en}</div>{!item.gwp && <div className="link" onClick={() => this.props.deleteFromCart(index)}><FontAwesomeIcon icon={faTimes} style={{ color: "black" }} /></div>}</div>
                    <div className="description">
                        <div className="item-desc">
                            <div><span className="item-title">{info.mat_name}</span></div>
                            <div><span className="variant_1">{info.variant_name_1}</span></div>
                            {info.variant_type_2 !== null && <div><span className="variant_2">{info.variant_name_2}</span></div>}
                        </div>
                        <div className="quantity">
                            {item.quantity}
                        </div>
                        <div className="price">
                            {item.discount === 0 && <span>{moneyFormat(item.unit_price, '฿')}</span>}
                            {item.discount !== 0 &&
                                <div>
                                    <div className="net-price">{moneyFormat(item.unit_price, '฿')}</div>
                                    <div className="original-price">{item.unit_price < item.mat_price && <del>{moneyFormat(item.mat_price, '฿')}</del>}</div>
                                </div>
                            }
                        </div>
                    </div>

                </div>
            </div>
        );
    }

    renderItems(items) {
        if (!items) return null;
        return items.map((item, index) => {
            return this.renderItem(item, index);
        });
    }

    render() {
        const { count, cart_items, delivery_cost, delivery_default, translate } = this.props; //items
        const { cartVisible, vh } = this.state;
        return (
            <div className="" ref={e => this.cartBox = e}>
                <div className="link cart-link">
                    <div className="d-inline-flex flex-column align-items-center justify-content-center position-relative" onClick={() => { this.cartHandleClick(); }}>
                        <span className={`cart-badge ${count === 0 ? "hide" : ""}`}>{count}</span>
                        {/* <IconCart color="#fff" /> */}
                        <div className="cart-icon"><FontAwesomeIcon color="#fff" icon={faShoppingCart} /></div>
                        {/* <span>รถเข็น</span> */}
                    </div>
                </div>
                <div ref={e => this.cartWindow = e} className={`bt-dropdown bt-cart-popup d-flex flex-column ${cartVisible ? "" : "hidden"}`} style={{ height: cartVisible ? vh : 0 }}>
                    <div className="header"><div>{translate('SHOPPING_CART')} ({count})</div><div onClick={this.cartHandleClick}><FontAwesomeIcon icon={faTimes} style={{ height: "16px", width: "16px" }} /></div></div>
                    <div className="item-list">
                        {this.renderItems(cart_items)}
                    </div>
                    <div className="summary">
                        <div className="total">
                            <div className="line"><span>ยอดรวม</span><span className="">{moneyFormat(this.props.total - delivery_cost, '฿')}</span></div>
                            <div className="line"><span>ค่าจัดส่ง</span><span className={delivery_cost === 0 ? "strike-through" : ""}>{delivery_cost === 0 ? moneyFormat(delivery_default, '฿') : moneyFormat(delivery_cost, '฿')}</span></div>
                            <div className="line last"><span>ยอดรวมทั้งหมด</span><span className="">{moneyFormat(this.props.total, '฿')}</span></div>
                        </div>
                        <div className="proceed_button">
                            <Link to={`/checkout`} onClick={() => { this.cartHandleClick() }} className="text-uppercase btn btn-gradient">{translate('VIEW_CART')}</Link>
                            {/* {authenticated
                                ?   <Link to={`/checkout`} onClick={() => {this.setState({cartVisible: false}); this.props.lockScroll(false);}} className="text-uppercase btn btn-gradient">{translate('VIEW_CART')}</Link>  
                                :   <a href='#' className="text-uppercase btn btn-gradient" onClick={e => {e.preventDefault(); this.props.showAuthenticationPopup();}}>{translate('VIEW_CART')}</a>
                            } */}
                        </div>
                    </div>
                </div>
            </div>
        )
    }
    render_old() {
        const { count, cart_items, delivery_cost, translate } = this.props; //items
        const { cartVisible } = this.state;
        return (
            <div className="u-basket d-inline-flex justify-content-center g-z-index-3">
                <div className="g-py-10 g-px-6">
                    <a href="#" id="basket-bar-invoker" className={`u-icon-v1 g-font-size-17 d-none d-xl-inline-block`} onMouseEnter={() => this.setState({ forceCloseCart: false })}
                        aria-controls="basket-bar"
                        aria-haspopup="true"
                        aria-expanded="false"
                        data-dropdown-event="hover"
                        data-dropdown-target="#basket-bar"
                        data-dropdown-type="simple"
                        data-dropdown-duration="0"
                        data-dropdown-hide-on-scroll="false"
                        data-dropdown-animation-in="fadeIn"
                        data-dropdown-animation-out="fadeOut"
                        data-dropdown-delay="100"
                    >
                        {/* <span className="fa-layers fa-fw">
                        <FontAwesomeIcon icon={["fas", "shopping-bag"]} style={{color: "white", height: "25.52px", width: "22.92px"}} />
                        <span className="fa-layers-text" data-fa-transform="shrink-2 down-7 right-4" style={{color:"black"}}>{items.length}</span>
                    </span> */}
                        <span className={`u-badge-v1--sm g-color-white g-font-size-11 g-line-height-1_4 g-rounded-50x g-pa-4 ${count === 0 ? "hide" : ""}`} style={{ top: "50%", right: "50%", background: "none" }}>{count}</span>
                        <FontAwesomeIcon color="#fff" icon={["fas", "shopping-bag"]} />
                    </a>
                    <a href="#" id="basket-bar-invoker" className="u-icon-v1 g-font-size-17 d-inline-flex justify-content-center align-items-center d-xl-none" onClick={() => { this.setState({ cartVisible: true }); this.props.lockScroll(true); }}>
                        <span className={`u-badge-v1--sm g-color-white g-font-size-11 g-line-height-1_4 g-rounded-50x g-pa-4 ${count === 0 ? "hide" : ""}`} style={{ top: "50%", right: "50%", background: "none" }}>{count}</span>
                        <FontAwesomeIcon color="#fff" icon={["fas", "shopping-bag"]} />
                    </a>
                </div>


                <div id="basket-bar" className={`d-none  ${this.state.forceCloseCart ? "d-xl-none" : "d-xl-block"} u-basket__bar u-baskey__bar--hidden u-dropdown--css-animation g-text-transform-none g-bg-white g-brd-around g-brd-gray-light-v4 arrow_box`}>
                    <span className="header">{translate('SHOPPING_CART')} ({count})</span>
                    <div className="item-list js-scrollbar">
                        {this.renderItems(cart_items)}
                    </div>
                    <div className="summary">
                        <div className="col-sm-12 total">
                            <span className="">ยอดรวม</span><span className="">{moneyFormat(this.props.total - delivery_cost, '฿')}</span>
                        </div>
                        <div className="col-sm-12 proceed_button">
                            <Link to={`/checkout`} className="text-uppercase btn btn-gradient">{translate('VIEW_CART')}</Link>
                            {/* {authenticated
                                ?   <Link to={`/checkout`} className="text-uppercase btn btn-gradient">{translate('VIEW_CART')}</Link>
                                :   <a href='#' className="text-uppercase btn btn-gradient" onClick={(e) => {e.preventDefault(); this.props.showAuthenticationPopup();}}>{translate('VIEW_CART')}</a>
                            } */}
                        </div>
                    </div>
                </div>
                {cartVisible &&
                    <div id="basket-bar-responsive" className="u-basket__bar u-dropdown--css-animation g-text-transform-none g-bg-white g-brd-around g-brd-gray-light-v4">
                        <div>
                            <span className="header">{translate('SHOPPING_CART')} ({count})</span>
                            <div onClick={() => { this.setState({ cartVisible: false }); this.props.lockScroll(false) }} className="close-btn"><FontAwesomeIcon icon={faTimes} /></div>
                            <div className="item-list">
                                {this.renderItems(cart_items)}
                            </div>
                        </div>
                        <div className="summary">
                            <div className="col-sm-12 total">
                                <span className="">ยอดรวม</span><span className="">{moneyFormat(this.props.total - delivery_cost, '฿')}</span>
                            </div>
                            <div className="col-sm-12 proceed_button">
                                <Link to={`/checkout`} onClick={() => { this.setState({ cartVisible: false }); this.props.lockScroll(false); }} className="text-uppercase btn btn-gradient">{translate('VIEW_CART')}</Link>
                                {/* {authenticated
                                    ?   <Link to={`/checkout`} onClick={() => {this.setState({cartVisible: false}); this.props.lockScroll(false);}} className="text-uppercase btn btn-gradient">{translate('VIEW_CART')}</Link>  
                                    :   <a href='#' className="text-uppercase btn btn-gradient" onClick={e => {e.preventDefault(); this.props.showAuthenticationPopup();}}>{translate('VIEW_CART')}</a>
                                } */}
                            </div>
                        </div>
                    </div>
                }
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        // authenticated: state.auth.authenticated,
        items: state.cart.items,
        count: state.cart.count,
        total: state.cart.total,
        cart_items: state.cart.cart_items,
        subtotal: state.cart.subtotal,
        delivery_cost: state.cart.delivery_cost,
        delivery_default: state.cart.delivery_default,
        translate: getTranslate(state.locale),
    }
}

export default withRouter(connect(mapStateToProps, { removeFromCart, deleteFromCart, lockScroll, getCart, processCart, updateCart, showAuthenticationPopup })(HeaderCart));